import React, { useState } from "react";
import { Form, Row } from "react-bootstrap";
import { CForm, CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from "@coreui/react";
// import FormWrapper from "../../../pagecomponents/Common/FormWrapper";
import { checkEmpty, toastMessage } from "../../../helpers/utility.js";

const JobChargesAddEditForm = ({saveData, closeModal, formPayload, isSaveDisabled}) => {
    const [formData, setFormData] = useState(formPayload);
    const [validated, setValidated] = useState(false);

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        
        // if (name === "job_charge_Name") {
        //     const isValid = /^[a-zA-Z\s]+$/.test(value); // Allows only letters and spaces
        //     if (!isValid) {
        //         toastMessage("error", "Special characters are not allowed in the input.");
        //         return;
        //     }
        // }

        setFormData({...formData, [name] : value});
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            console.log(formData);
            saveData(formData);
        }
        setValidated(true);
    };

    return(
        <CForm
        className="g-3 needs-validation"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        >
            <Row className="row-xs mb-2">
                <CCol md={12}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_charge_Name">Job Charge Name</CFormLabel>
                    <CFormInput
                        type="text"
                        id="charge_Name"
                        name="charge_Name"
                        value={formData.charge_Name}
                        onChange={handleInputChange}
                        required
                        // pattern="^[a-zA-Z\s]+$" // Ensures no special characters
                    />
                    <CFormFeedback invalid>Enter Job Charge Name</CFormFeedback>
                </CCol>
            </Row>
            <Row className="row-xs mb-2">
                <CCol md={12}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="charge_Type">Select Charge Type</CFormLabel>
                    <Form.Select
                        className="form-control"
                        id="charge_Type"
                        name="charge_Type"
                        value={formData.charge_Type}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">Select</option>
                        <option value="Revenue">Revenue</option>
                        <option value="Cost of Revenue">Cost of Revenue</option>
                    </Form.Select>
                    <CFormFeedback invalid>Enter Job Charge Type</CFormFeedback>
                </CCol>
            </Row>
            <Row className="row-xs mb-2 btn-animation">
                <CCol xs={12} className="mt-10">
                    <CButton 
                    color="primary" 
                    className={`btn btn-sm float-end ${isSaveDisabled ? 'btn-loaders' : ''}`}
                    type="submit"
                    disabled={isSaveDisabled}
                    >
                        {isSaveDisabled ? (<span className="loading">Save Changes</span>) : "Save Changes"}
                    </CButton>
                    <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal} disabled={isSaveDisabled}>Close</CButton>
                </CCol>
            </Row>
        </CForm>
    );
};

export default JobChargesAddEditForm;